import axios from "../utils/axios";

// Upload Media
export const uploadMedia = async (req) => {
    try {
        const { data } = await axios.post('/media/upload', req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};

/**
 * Delete single media file by ID
 * @param {number} id - Media ID
 * @returns {Promise}
 */
export const deleteMedia = async (id) => {
    try {
        const { data } = await axios.delete(`uploads/media/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteMedia error:", error);
        throw error;
    }
};

/**
 * Delete multiple media files by IDs
 * @param {Array<number>} ids - Array of media IDs
 * @returns {Promise}
 */
export const deleteMultipleMedia = async (ids = []) => {
    try {
        const params = {};

        // Build query params: ids[]=1&ids[]=2
        if (ids && ids.length > 0) {
            ids.forEach((id, index) => {
                params[`ids[${index}]`] = id;
            });
        }

        const { data } = await axios.delete("uploads/media", {
            params,
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteMultipleMedia error:", error);
        throw error;
    }
};